import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import styles from "./page_styles.module.scss";
import globalStyles from "../global.module.scss";
import { marked } from "marked";
import client from "../services/contentful.js";
import Footer from "../components/Footer/Footer";

const Ginskolan = () => {
  const [isLoading, setisLoading] = useState(true);
  const [guideBanner, setGuideBanner] = useState("");
  const [content, setContent] = useState([]);

  useEffect(() => {
    const getBannerContent = () => {
      client.getEntry("6Mh1r6PZ40QPpMGYYZxwMT").then((entry) => {
        setContent(entry.fields);
        setGuideBanner(entry.fields.banner.fields.file.url);
      });

      setisLoading(false);
    };

    getBannerContent();
  }, []);

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <div className={styles.container}>
          <Navbar />
          <div
            className={styles.banner}
            style={{ backgroundImage: `URL(https:${guideBanner})` }}
          >
            <h1 className={globalStyles.max_width}>{content.title}</h1>
          </div>
          <div
            style={{ maxWidth: "1200px" }}
            className={`${styles.content} ${styles.ginskolan_faq_extra} ${globalStyles.max_width}`}
            dangerouslySetInnerHTML={{
              __html: marked(
                content.beskrivning !== undefined || null
                  ? content.beskrivning
                  : ""
              ),
            }}
          />
          <div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default Ginskolan;
